/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FieldPhoneSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FieldPhoneSmall',
      'aria-hidden': true,
      focusable: false,
      width:  15 * scale,
      height: 15 * scale,
      viewBox: '0 0 15 15',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M14 2.4c-.7 6-5.5 10.8-11.6 11.3L1 10.1l4.1-1.9 1.8 1.9c1.3-.9 2.5-2.1 3.4-3.4L8.4 4.8l2-3.8z"}))
}
